import { render, staticRenderFns } from "./form-business.vue?vue&type=template&id=d0758f1c"
import script from "./form-business.vue?vue&type=script&lang=js"
export * from "./form-business.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports